import React, { Component } from 'react';
import {CommonOptionSelect,CommonInput,CommonTextarea, KryptisLaukas} from './common';
import college from '../pages/college'

class UserRoleInfo extends Component {
  static defaultProps = {
      isHaveProject: '有', // for debug
  }
  constructor(props) {
    super(props);
    this.state = { ...props}
    this.debug = false
    this.debug && console.log("[UserRoleInfo]--props ------>" + JSON.stringify(this.state))
    this.userRoleTitleMap = {
      default : {
        'org': '机构名称:',
        'position': '职称:',
        'self_intro_title': '个人简介:',
        'self_intro_tip': '请填写个人介绍（800字以内）',
      },
      1: {
        'org': '机构名称:',
        'position': '职称:',
      },
      2: {
        'org': '机构名称:',
        'position': '职称:',
      },
      3: {
        'org': '机构名称:',
        'position': '职称:',
      },
      4: {
        'org': '机构名称:',
        'position': '职位:',
        'self_intro_title': '地方简介:',
        'self_intro_tip': '请简介所在地方优势产业及未来重点发展产业，以及希望我们能给您提供哪些帮助/合作意向）',
      },
      5: {
        'org': '机构名称:',
        'position': '职称:',
      },
      6: {
        'org': '学校名称:',
        'position': '学历:',
      },
      7: {
        'org': '学校名称:',
        'position': '职称:',
      },
      8: {
        'org': '机构名称:',
        'position': '职位:',
        'self_intro_title': '园区简介:',
        'self_intro_tip': '请简介园区优势产业及未来重点发展产业，以及希望我们能给您提供哪些帮助/合作意向', 
      }
    }
    this.studentPositionList = ['本科在读', '研究生在读', '博士及以上在读', '其他']
  }
  componentDidMount() {
    this.emitData()
    setTimeout(()=> {
      if (this.props.userRole == 6 && this.studentPositionList.indexOf(this.props.title_or_edu) == -1) {
        this.setState({ title_or_edu: '本科在读'})
      }
    }, 1500)
  }
  emitData = () => {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  validateFunction = () => {
    let flag = true
    const validateMap = new Map();
    let projectVliArr = ['org_name', 'title_or_edu', 'industry', 'company_or_person_intro'];
    validateMap.set('classValidate', projectVliArr);

    for (let i in this.state) {
      if (validateMap.get('classValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      if (i === 'industry' && validateMap.get('classValidate').indexOf(i) > -1 && (!this.state[i][0] || !this.state[i][1])) {
        flag = false;
      }
    }
    return flag;
  }
  onCommonValueChange = (data) => {
    this.setState(data)
    console.log("[UserRoleInfo] onCommonValueChange --> " +  JSON.stringify(this.state))
    this.setState({ ...data }, () => { this.emitData()});
  }

  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
      if (index === 'kryptis' && this.state.industry) {
        this.state.industry[0] = resObj[index] ;
      }
      if (index === 'laukas' && this.state.industry) {
        this.state.industry[1] = resObj[index];
      }
    }
    this.setState({ ...resObj }, () => { this.emitData() });
  }


  render() {
    const kryptisLaukas = {
      kryptis: this.state.industry && this.state.industry.length > 0 ? this.state.industry[0] : '',
      laukas: this.state.industry && this.state.industry.length > 1 ? this.state.industry[1] : ''
    }
    if (!this.state.industry) {
      this.state.industry = ['', ''];
    }
    return (
      <div>
        { this.debug &&
          <div>
            <p> user role info : </p>
            <p> {JSON.stringify(this.props,null,2) }</p>
          </div>
        }
        <CommonInput
          title = {this.userRoleTitleMap[this.props.userRole || 'default'].org}
          name = {"org_name"}
          value = {this.state.org_name }
          checkErr= {this.props.checkErr}
          errorMsg={"请填写"}
          onValueChange={this.onCommonValueChange}/>
        {
          this.props.userRole != 6 && 
          <CommonInput
            title = {this.userRoleTitleMap[this.props.userRole || 'default'].position}
            name = {"title_or_edu"}
            value = {this.state.title_or_edu}
            checkErr= {this.props.checkErr}
            errorMsg={"请填写"}
            onValueChange={this.onCommonValueChange}/>
        }
        {
          this.props.userRole == 6 && 
          <CommonOptionSelect
            title = {this.userRoleTitleMap[this.props.userRole || 'default'].position}
            selectedVal={this.state.title_or_edu}
            name={'title_or_edu'}
            checkErr={this.state.checkErr}
            option_list={this.studentPositionList}
            onSelectOption={ this.onCommonValueChange }/>
        }
        <KryptisLaukas
          {...kryptisLaukas}
          recive_title={'关注领域:'}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}/>
        <CommonTextarea
          title = {this.userRoleTitleMap[this.props.userRole].self_intro_title || this.userRoleTitleMap['default'].self_intro_title}
          holder = {this.userRoleTitleMap[this.props.userRole].self_intro_tip || this.userRoleTitleMap['default'].self_intro_tip}
          name = {"company_or_person_intro"}
          maxLength={800}
          value = {this.state.company_or_person_intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.onCommonValueChange}/>
      </div>
    )
  }
}
export default UserRoleInfo;
